<template>
    <div>
        <ComplianceRequirementsSection
            :count="requirements.length"
            :loaded="loaded"
            :show-heading="showRequirementsHeading"
        >
            <ComplexRegulationRequirementItem
                v-for="(requirement, index) in requirements"
                :key="requirement.id"
                :number="index + 1"
                :requirement="requirement"
                :property-config="propertyConfig"
                :expanded="isExpanded(requirement)"
                :show-substance-requirement-status="showSubstanceRequirementStatus"
                @toggle="toggleRequirement(requirement)"
                @select="openSelector"
                @action="$emit('action', $event)"
            />
        </ComplianceRequirementsSection>

        <SubstanceListSelectorModal
            v-if="selectorSession"
            ref="selector"
            :list="selectorSession.requirement.list"
            :legislations="selectorSession.requirement.legislations"
            :product="selectorSession.product"
            :included-substances="selectorSession.included"
            :excluded-substances="selectorSession.excluded"
            :allowed-list-ids="selectorSession.entry.selectorListIds"
            :show-questions="false"
            :show-no-single-parts-checkbox="true"
            :disable-automatic-question-state-inference="true"
            @include="includeSubstance"
            @exclude="excludeSubstance"
            @undefined="makeSubstanceUndefined"
            @closed="closeSelector"
        />
    </div>
</template>

<script>
import ComplianceRequirementsSection from './ComplianceRequirementsSection.vue'
import ComplexRegulationRequirementItem from './ComplexRegulationRequirementItem.vue'
import SubstanceListSelectorModal from './SubstanceListSelectorModal.vue'

export default {
    name: 'ComplexProductComplianceOverview',
    components: {
        ComplianceRequirementsSection,
        ComplexRegulationRequirementItem,
        SubstanceListSelectorModal,
    },
    props: {
        requirements: { type: Array, required: true },
        context: { type: Object, required: true },
        propertyConfig: { type: Object, required: true },
        loaded: { type: Boolean, default: false },
        substanceComponent: { type: String, default: 'SubstanceV4' },
        showRequirementsHeading: { type: Boolean, default: false },
        showSubstanceRequirementStatus: { type: Boolean, default: true },
    },
    data() {
        return {
            expandedByRequirementId: {},
            selectorSession: null,
        }
    },
    watch: {
        requirements: {
            immediate: true,
            handler(requirements) {
                requirements.forEach(requirement => {
                    const id = String(requirement.id)
                    if (!Object.prototype.hasOwnProperty.call(this.expandedByRequirementId, id)) {
                        this.$set(
                            this.expandedByRequirementId,
                            id,
                            requirement.status !== 'complete',
                        )
                    }
                })
            },
        },
    },
    methods: {
        isExpanded(requirement) {
            return this.expandedByRequirementId[String(requirement.id)] !== false
        },
        toggleRequirement(requirement) {
            const id = String(requirement.id)
            this.$set(this.expandedByRequirementId, id, !this.isExpanded(requirement))
        },
        openSelector({ entry, requirement, createSaveCallbacks = () => ({}) }) {
            this.$emit('action', {
                type: 'component-selector.open',
                payload: {
                    componentId: entry.product.id,
                    successCallback: data => {
                        this.selectorSession = {
                            entry,
                            requirement,
                            createSaveCallbacks,
                            ...data,
                        }
                        this.$nextTick(() => {
                            if (this.$refs.selector && typeof this.$refs.selector.show === 'function') {
                                this.$refs.selector.show()
                            }
                        })
                    },
                },
            })
        },
        selectorAction(type, payload = {}) {
            this.$emit('action', {
                type,
                payload: {
                    componentId: this.selectorSession.entry.product.id,
                    draft: true,
                    ...payload,
                },
            })
        },
        includeSubstance(substance, substanceListIds) {
            this.selectorAction('component-substance.include', { substance, substanceListIds })
        },
        excludeSubstance(substance) {
            this.selectorAction('component-substance.exclude', { substance })
        },
        makeSubstanceUndefined(substance) {
            this.selectorAction('component-substance.undefined', { substance })
        },
        closeSelector() {
            this.selectorAction(
                'component-selector.closed',
                this.selectorSession.createSaveCallbacks(),
            )
            this.selectorSession = null
        },
    },
}
</script>
